var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import EnhancedAxiosPlugin from '@/plugins/enhanced-axios';
import { loadFonts } from './plugins/webfontloader';
import '@mdi/font/css/materialdesignicons.css';
// 导入 Vue3VideoPlayer
// @ts-ignore
import Vue3VideoPlayer from '@cloudgeek/vue3-video-player';
import '@cloudgeek/vue3-video-player/dist/vue3-video-player.css';
loadFonts();
// 异步初始化应用
function initApp() {
    return __awaiter(this, void 0, void 0, function () {
        var app, apiBaseURL, timestamp, response, config, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    app = createApp(App);
                    apiBaseURL = 'https://s1.sanyan.vip' // 默认值
                    ;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    timestamp = new Date().getTime();
                    return [4 /*yield*/, fetch("/config.json?t=".concat(timestamp))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    config = _a.sent();
                    console.log('配置文件加载成功:', config);
                    // 全局资源基地址 - 从配置文件读取
                    app.provide('baseURL', {
                        baseMediaURL: config.baseMediaURL,
                        baseSysURL: config.baseSysURL
                    });
                    // 设置API基地址
                    apiBaseURL = config.apiBaseURL || config.baseSysURL;
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error('配置文件加载失败，使用默认配置:', error_1);
                    // 使用默认配置
                    app.provide('baseURL', {
                        baseMediaURL: 'https://test1.sanyan.vip/',
                        baseSysURL: 'https://s1.sanyan.vip'
                    });
                    return [3 /*break*/, 5];
                case 5:
                    // 使用EnhancedAxiosPlugin插件，并传入配置
                    app.use(EnhancedAxiosPlugin, {
                        baseURL: apiBaseURL,
                        timeout: 20000,
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        errorHandler: function (error) {
                            console.error('API错误:', error);
                            // 可以在这里添加统一的错误处理，比如显示提示等
                        },
                        refreshTokenConfig: {
                            url: '/api/Auth/RefreshToken',
                            method: 'POST'
                        }
                    });
                    // 注册 Vue3VideoPlayer 组件
                    app.use(Vue3VideoPlayer, {
                        lang: 'zh-CN' // 设置为中文
                    });
                    app.use(router)
                        .use(store)
                        .use(vuetify)
                        .mount('#app');
                    return [2 /*return*/];
            }
        });
    });
}
// 启动应用
initApp();
